/**
 * @author: dwi.setiyadi@gmail.com
*/

import React from 'react';

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config

// import RouterPortal from '../modules/portal/RouterPortal';
import RouterDashboard from '../modules/dashboard/RouterDashboard';
import RouterUserManagement from '../modules/user-management/RouterUserManagement';
import RouterUsersTemp from '../modules/users-temp/RouterUsersTemp';
import RouterRoleManagement from '../modules/role-management/RouterRoleManagement';
import RouterApplication from '../modules/application/RouterApplication';
import RouterPermissionRole from '../modules/permission-role/RouterPermissionRole';
import RouterMasterData from '../modules/master-data/RouterMasterData';

export const RouterContainer = [
  ...RouterRoleManagement,
  ...RouterUserManagement,
  ...RouterUsersTemp,
  ...RouterApplication,
  ...RouterPermissionRole,
  ...RouterMasterData
];

export const RouterNonContainer = [
  {
    path: '/login',
    exact: true,
    name: 'Login',
    component: React.lazy(() => import('../modules/auth/views/NewLogin')),
  },
  // {
  //   path: '/register',
  //   exact: true,
  //   name: 'Register',
  //   component: React.lazy(() => import('../modules/example/views/Pages/Register/Register')),
  // },
  {
    path: '/404',
    exact: true,
    name: '404 Not Found',
    component: React.lazy(() => import('../modules/example/views/Pages/Page404/Page404')),
  },
  {
    path: '/500',
    exact: true,
    name: '500 Internal Server Error',
    component: React.lazy(() => import('../modules/example/views/Pages/Page500/Page500')),
  },
  ...RouterDashboard,
  // ...RouterPortal,
];
